export const Header = () => {
  return (
    <header className="bg-white flex items-center justify-between py-3 px-5 shadow border-gray-100 border-b-2">
      <span className="text-2xl font-bold italic text-blue-500">amx360</span>
    </header>
  );
};
